require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-un-rapporeturs-aiib-promote-and-protect-pwd-esf-review.json") })
        }
      }, "path---en-us-update-un-rapporeturs-aiib-promote-and-protect-pwd-esf-review");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-un-rapporeturs-aiib-promote-and-protect-pwd-esf-review!./.cache/json/en-us-update-un-rapporeturs-aiib-promote-and-protect-pwd-esf-review.json
// module id = 817
// module chunks = 231608221292675